import {Component} from "../../..";
import {OnActive} from "../../../scripts/util";
import {Api} from "../../../shared";

export function ViewCard({component, click, children}: {component?: Api.Staff.Component.Type, click?: () => unknown, children?: any})
{
	let contents: JSX.Element = <></>;

	if(component) {
		contents = (<>
			{children}
			<p>{component.name}</p>
		</>);
	}

	return (
		<Component.Card {...OnActive(click)}>
			{contents}
		</Component.Card>
	);
}

